import React from 'react';
import {
 Moon, Sun
} from 'lucide-react';
import {
 useTheme
} from './ThemeProvider';

export function ThemeToggle() {
  const {
 theme, setTheme
} = useTheme();

  const toggleTheme = () => {
    if (theme === 'light' || theme === 'system') setTheme('dark');
    else setTheme('light');
  };

  return (
      <button
      onClick={toggleTheme}
      className="inline-flex items-center justify-center rounded-md p-2 text-sm font-medium transition-colors hover:bg-gray-100 dark:hover:bg-gray-800 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50"
      aria-label="Toggle theme"
    >
          <Sun className="h-5 w-5 dark:hidden" />
          <Moon className="hidden h-5 w-5 dark:block" />
          <span className="sr-only">Toggle theme</span>
      </button>
  );
}
